import React, { useState, useEffect } from 'react';
import i18n from '../i18n';
import apiClient from '../services/api';

// 翻译文本的函数
const translateText = async (text) => {
  // 如果没有文本，返回空字符串
  if (!text) {
    return '';
  }
  
  // 如果当前语言是英文，直接返回原始文本
  if (i18n.language === 'en') {
    return text;
  }
  
  // 否则，调用API翻译
  try {
    const response = await apiClient.post('/translation/translate', {
      text: text,
      targetLanguage: i18n.language === 'zh' ? 'zh' : i18n.language,
      sourceLanguage: 'en'
    });
    
    if (response.data && response.data.translatedText) {
      return response.data.translatedText;
    } else {
      return text;
    }
  } catch (error) {
    console.error('[翻译错误] 翻译API调用失败:', error);
    return text;
  }
};

// 翻译文本的组件
const TranslateText = ({ text }) => {
  const [translatedText, setTranslatedText] = useState(text || '');
  const [currentLang, setCurrentLang] = useState(i18n.language);
  
  useEffect(() => {
    // 监听语言变化事件
    const handleLanguageChange = (lng) => {
      setCurrentLang(lng);
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    
    // 清理函数
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);
  
  useEffect(() => {
    const translate = async () => {
      if (!text) {
        setTranslatedText('');
        return;
      }
      
      if (currentLang !== 'en') {
        try {
          const translated = await translateText(text);
          setTranslatedText(translated || text);
        } catch (error) {
          console.error('[翻译错误] 无法翻译文本:', error);
          setTranslatedText(text);
        }
      } else {
        setTranslatedText(text);
      }
    };
    
    translate();
  }, [text, currentLang]); // 依赖于text和currentLang
  
  return <>{translatedText}</>;
};

export default TranslateText;
export { translateText };